import  { useEffect } from 'react';
import { useAppDispatch, useAppSelector } from '../../store/store';
import { removeSnackbar } from '../../store/app-slice/app';
import { useSnackbar } from 'notistack';

let displayedNotifications: any[] = [];

const useNotifications = () => {
  const notifications = useAppSelector(
    (store: any) => store.app.notifications ?? []
  );
  const dispatch = useAppDispatch();
  const { enqueueSnackbar, closeSnackbar } = useSnackbar();

  const saveDisplayedNotifications = (id: any) =>
    (displayedNotifications = [...displayedNotifications, id]);
  const removeDisplayedNotifications = (id: any) =>
    (displayedNotifications = [
      ...displayedNotifications.filter((key) => id !== key),
    ]);

  useEffect(() => {
    notifications.forEach(({ message, options, dismissed = false }: any) => {
      if (dismissed) {
        closeSnackbar(options.key);
        return;
      }

      if (displayedNotifications.includes(options.key)) return;

      enqueueSnackbar(message ?? (options?.variant || 'error'), {
        ...options,
        variant: options?.variant || 'error',
        onClose: (event : any, reason : any, myKey : any) => {
          if (options.onClose) {
            options.onClose(event, reason, myKey);
          }
        },
        onExited: (event : any, myKey : any) => {
          dispatch(removeSnackbar(myKey));
          removeDisplayedNotifications(myKey);
        },
      });

      saveDisplayedNotifications(options.key);
    });
  }, [notifications, closeSnackbar, enqueueSnackbar, dispatch]);
};

export default useNotifications;
